import api from './api';
import { Enrollment } from '../types';

export const enrollmentService = {
  listMyEnrollments: async () => {
    const response = await api.get<{ enrollments: Enrollment[] }>('/enrollments/me');
    return response.data.enrollments;
  },
  listByCourse: async (courseId: number) => {
    if (!courseId || courseId === null || courseId === undefined) {
      console.error('Invalid courseId:', courseId);
      throw new Error('Course ID is required');
    }
    try {
      const response = await api.get<{ enrollments: Enrollment[] }>(`/enrollments/course/${courseId}`);
      return response.data.enrollments;
    } catch (error: any) {
      throw error;
    }
  },
  create: async (userId: number, courseId: number) => {
    const response = await api.post<{ message: string; enrollment: Enrollment }>(`/enrollments`, {
      user_id: userId,
      course_id: courseId,
    });
    return response.data.enrollment;
  },
  update: async (enrollmentId: number, payload: Partial<Enrollment>) => {
    const response = await api.put<{ message: string; enrollment: Enrollment }>(`/enrollments/${enrollmentId}`, payload);
    return response.data.enrollment;
  },
  delete: async (enrollmentId: number) => {
    const response = await api.delete<{ message: string }>(`/enrollments/${enrollmentId}`);
    return response.data;
  },
  grantPoints: async (enrollmentId: number, points: number) => {
    const response = await api.post<{ message: string; user_level: any }>(`/enrollments/${enrollmentId}/grant-points`, {
      points,
    });
    return response.data;
  },
};



